<template>
  <div>
      <div class="container" id="education">
          <div class="title">
            <h1>Education</h1> 
          </div>
          <div class="table">
              <ul>
                  <li>
                      <div v-for="itemEducation in itemsEducation" :key="itemEducation.id">
                        <div class="time-block"> 
                            <p><strong> {{ itemEducation.content.time }} </strong></p>
                            <p> {{ itemEducation.content.place }} </p>
                        </div>
                        <div class="text-block">
                            <p><strong> {{ itemEducation.content.name }} </strong></p>
                            <p v-html="itemEducation.content.description.content"></p>
                        </div>
                      </div>
                  </li>
              </ul>
          </div>
      </div>
      <LadybugAnimation1></LadybugAnimation1>
      <div class="container" id="experience">
        <div class="title">
            <h1>Experience</h1> 
         </div>
         <div class="table">
             <ul>
                 <li>
                    <div v-for="itemExperience in itemsExperience" :key="itemExperience.id"> 
                        <div class="time-block">
                            <p><strong>{{ itemExperience.content.time }}</strong></p>
                            <p>{{ itemExperience.content.place }}</p>
                        </div>
                        <div class="text-block">
                            <p><strong>{{ itemExperience.content.name }} </strong></p>
                            <p v-html="itemExperience.content.description.content"></p>
                        </div>
                    </div>
                 </li>
              </ul>
         </div>
      </div>
  </div>
</template>



<script>
import LadybugAnimation1 from '@/components/LadybugAnimation1.vue'

const StoryblokClient = require('storyblok-js-client');
const Storyblok = new StoryblokClient({
  accessToken: process.env.VUE_APP_KEY,
  cache: {
    clear: 'auto',
    type: 'memory'
  }
});

export default {
  name: 'about-me',
  components: {
    LadybugAnimation1
  },
  methods: {
      getEducation() {
            Storyblok.get('cdn/stories', {
                "starts_with": "portfolio/education/"
            })
            .then(response => {
                this.itemsEducation = response.data.stories;
            }).catch(error => { 
                console.log(error)
            })
        },
        getExperience() {
            Storyblok.get('cdn/stories', {
                "starts_with": "portfolio/experience/"
            })
            .then(response => {
                this.itemsExperience = response.data.stories;
            }).catch(error => { 
                console.log(error)
            })
        },
    },
     data: function () {
        return {
            itemsEducation: [],
            itemsExperience: [],
        }
    },
    mounted() {
        this.getEducation();
        this.getExperience();
    }
}
</script>



<style>
#education {
    padding: 140px 0 0;
}
#experience {
    padding: 70px 0 50px;
}
.title {
    position: relative;
    display: inline-block;
    width: 24%;
    vertical-align: top;
    color: #F3A822 ;
}
.table {
    position: relative;
    display: inline-block;
    width: 75%;
    text-align: left;
    
}
ul {
    list-style-type: none;
}
.time-block {
    position: relative;
    display: inline-block;
    width: 30%;
    vertical-align: top;
    color: #085561;
}
.text-block {
    position: relative;
    display: inline-block;
    width: 60%;
}

@media only screen 
and (min-device-width : 768px) and (max-device-width : 1024px) {
.title {
    width: 75%;
    padding-bottom: 1.5rem;
  }
.table {
    width: 85%;
}
.text-block {
    width: 69%;
}
}
@media only screen and (max-width: 600px) {
#education {
    padding: 40px 0 0;
}
#experience {
    padding-bottom: 20px;
}
.title {
    width: 75%;
    padding-bottom: 1rem;
}
.title h1 {
    font-size: 2rem;
}
.table {
    width: 84%;
}
.table p {
    margin-bottom: 0;
}
.text-block {
    margin-bottom: 1.5rem;
    width: 69%;
    padding-left: 0.5rem;
}
ul {
    padding-left: 0.5rem;
}
}
</style>